/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as LayoutRouteImport } from "./routes/_layout"
import { Route as LayoutIndexRouteImport } from "./routes/_layout/index"
import { Route as LayoutSwapRouteImport } from "./routes/_layout/swap"
import { Route as LayoutDefiRouteImport } from "./routes/_layout/defi"
import { Route as LayoutStakingIndexRouteImport } from "./routes/_layout/staking.index"
import { Route as LayoutDefiIndexRouteImport } from "./routes/_layout/defi.index"
import { Route as LayoutStakingAssetRouteImport } from "./routes/_layout/staking.$asset"
import { Route as LayoutDefiStablecoinsRouteImport } from "./routes/_layout/defi.stablecoins"
import { Route as LayoutDefiProtocolsRouteImport } from "./routes/_layout/defi.protocols"
import { Route as LayoutDefiPositionsRouteImport } from "./routes/_layout/defi.positions"
import { Route as LayoutStakingAssetIndexRouteImport } from "./routes/_layout/staking.$asset.index"
import { Route as LayoutDefiStablecoinsIndexRouteImport } from "./routes/_layout/defi.stablecoins.index"
import { Route as LayoutDefiProtocolsIndexRouteImport } from "./routes/_layout/defi.protocols.index"
import { Route as LayoutDefiPositionsIndexRouteImport } from "./routes/_layout/defi.positions.index"
import { Route as LayoutStakingAssetUnstakeRouteImport } from "./routes/_layout/staking.$asset.unstake"
import { Route as LayoutStakingAssetStakeRouteImport } from "./routes/_layout/staking.$asset.stake"
import { Route as LayoutStakingAssetClaimRouteImport } from "./routes/_layout/staking.$asset.claim"
import { Route as LayoutDefiStablecoinsTokenAddressRouteImport } from "./routes/_layout/defi.stablecoins.$tokenAddress"
import { Route as LayoutDefiProtocolsProtocolKeyRouteImport } from "./routes/_layout/defi.protocols.$protocolKey"
import { Route as LayoutDefiPositionsPositionAddressRouteImport } from "./routes/_layout/defi.positions.$positionAddress"
import { Route as LayoutDefiPoolTokenAddressProtocolIdRouteImport } from "./routes/_layout/defi.pool.$tokenAddress.$protocolId"

const LayoutRoute = LayoutRouteImport.update({
  id: "/_layout",
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutIndexRoute = LayoutIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutSwapRoute = LayoutSwapRouteImport.update({
  id: "/swap",
  path: "/swap",
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutDefiRoute = LayoutDefiRouteImport.update({
  id: "/defi",
  path: "/defi",
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutStakingIndexRoute = LayoutStakingIndexRouteImport.update({
  id: "/staking/",
  path: "/staking/",
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutDefiIndexRoute = LayoutDefiIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => LayoutDefiRoute,
} as any)
const LayoutStakingAssetRoute = LayoutStakingAssetRouteImport.update({
  id: "/staking/$asset",
  path: "/staking/$asset",
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutDefiStablecoinsRoute = LayoutDefiStablecoinsRouteImport.update({
  id: "/stablecoins",
  path: "/stablecoins",
  getParentRoute: () => LayoutDefiRoute,
} as any)
const LayoutDefiProtocolsRoute = LayoutDefiProtocolsRouteImport.update({
  id: "/protocols",
  path: "/protocols",
  getParentRoute: () => LayoutDefiRoute,
} as any)
const LayoutDefiPositionsRoute = LayoutDefiPositionsRouteImport.update({
  id: "/positions",
  path: "/positions",
  getParentRoute: () => LayoutDefiRoute,
} as any)
const LayoutStakingAssetIndexRoute = LayoutStakingAssetIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => LayoutStakingAssetRoute,
} as any)
const LayoutDefiStablecoinsIndexRoute =
  LayoutDefiStablecoinsIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => LayoutDefiStablecoinsRoute,
  } as any)
const LayoutDefiProtocolsIndexRoute =
  LayoutDefiProtocolsIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => LayoutDefiProtocolsRoute,
  } as any)
const LayoutDefiPositionsIndexRoute =
  LayoutDefiPositionsIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => LayoutDefiPositionsRoute,
  } as any)
const LayoutStakingAssetUnstakeRoute =
  LayoutStakingAssetUnstakeRouteImport.update({
    id: "/unstake",
    path: "/unstake",
    getParentRoute: () => LayoutStakingAssetRoute,
  } as any)
const LayoutStakingAssetStakeRoute = LayoutStakingAssetStakeRouteImport.update({
  id: "/stake",
  path: "/stake",
  getParentRoute: () => LayoutStakingAssetRoute,
} as any)
const LayoutStakingAssetClaimRoute = LayoutStakingAssetClaimRouteImport.update({
  id: "/claim",
  path: "/claim",
  getParentRoute: () => LayoutStakingAssetRoute,
} as any)
const LayoutDefiStablecoinsTokenAddressRoute =
  LayoutDefiStablecoinsTokenAddressRouteImport.update({
    id: "/$tokenAddress",
    path: "/$tokenAddress",
    getParentRoute: () => LayoutDefiStablecoinsRoute,
  } as any)
const LayoutDefiProtocolsProtocolKeyRoute =
  LayoutDefiProtocolsProtocolKeyRouteImport.update({
    id: "/$protocolKey",
    path: "/$protocolKey",
    getParentRoute: () => LayoutDefiProtocolsRoute,
  } as any)
const LayoutDefiPositionsPositionAddressRoute =
  LayoutDefiPositionsPositionAddressRouteImport.update({
    id: "/$positionAddress",
    path: "/$positionAddress",
    getParentRoute: () => LayoutDefiPositionsRoute,
  } as any)
const LayoutDefiPoolTokenAddressProtocolIdRoute =
  LayoutDefiPoolTokenAddressProtocolIdRouteImport.update({
    id: "/pool/$tokenAddress/$protocolId",
    path: "/pool/$tokenAddress/$protocolId",
    getParentRoute: () => LayoutDefiRoute,
  } as any)

export interface FileRoutesByFullPath {
  "/": typeof LayoutIndexRoute
  "/defi": typeof LayoutDefiRouteWithChildren
  "/swap": typeof LayoutSwapRoute
  "/defi/positions": typeof LayoutDefiPositionsRouteWithChildren
  "/defi/protocols": typeof LayoutDefiProtocolsRouteWithChildren
  "/defi/stablecoins": typeof LayoutDefiStablecoinsRouteWithChildren
  "/staking/$asset": typeof LayoutStakingAssetRouteWithChildren
  "/defi/": typeof LayoutDefiIndexRoute
  "/staking/": typeof LayoutStakingIndexRoute
  "/defi/positions/$positionAddress": typeof LayoutDefiPositionsPositionAddressRoute
  "/defi/protocols/$protocolKey": typeof LayoutDefiProtocolsProtocolKeyRoute
  "/defi/stablecoins/$tokenAddress": typeof LayoutDefiStablecoinsTokenAddressRoute
  "/staking/$asset/claim": typeof LayoutStakingAssetClaimRoute
  "/staking/$asset/stake": typeof LayoutStakingAssetStakeRoute
  "/staking/$asset/unstake": typeof LayoutStakingAssetUnstakeRoute
  "/defi/positions/": typeof LayoutDefiPositionsIndexRoute
  "/defi/protocols/": typeof LayoutDefiProtocolsIndexRoute
  "/defi/stablecoins/": typeof LayoutDefiStablecoinsIndexRoute
  "/staking/$asset/": typeof LayoutStakingAssetIndexRoute
  "/defi/pool/$tokenAddress/$protocolId": typeof LayoutDefiPoolTokenAddressProtocolIdRoute
}
export interface FileRoutesByTo {
  "/swap": typeof LayoutSwapRoute
  "/": typeof LayoutIndexRoute
  "/defi": typeof LayoutDefiIndexRoute
  "/staking": typeof LayoutStakingIndexRoute
  "/defi/positions/$positionAddress": typeof LayoutDefiPositionsPositionAddressRoute
  "/defi/protocols/$protocolKey": typeof LayoutDefiProtocolsProtocolKeyRoute
  "/defi/stablecoins/$tokenAddress": typeof LayoutDefiStablecoinsTokenAddressRoute
  "/staking/$asset/claim": typeof LayoutStakingAssetClaimRoute
  "/staking/$asset/stake": typeof LayoutStakingAssetStakeRoute
  "/staking/$asset/unstake": typeof LayoutStakingAssetUnstakeRoute
  "/defi/positions": typeof LayoutDefiPositionsIndexRoute
  "/defi/protocols": typeof LayoutDefiProtocolsIndexRoute
  "/defi/stablecoins": typeof LayoutDefiStablecoinsIndexRoute
  "/staking/$asset": typeof LayoutStakingAssetIndexRoute
  "/defi/pool/$tokenAddress/$protocolId": typeof LayoutDefiPoolTokenAddressProtocolIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/_layout": typeof LayoutRouteWithChildren
  "/_layout/defi": typeof LayoutDefiRouteWithChildren
  "/_layout/swap": typeof LayoutSwapRoute
  "/_layout/": typeof LayoutIndexRoute
  "/_layout/defi/positions": typeof LayoutDefiPositionsRouteWithChildren
  "/_layout/defi/protocols": typeof LayoutDefiProtocolsRouteWithChildren
  "/_layout/defi/stablecoins": typeof LayoutDefiStablecoinsRouteWithChildren
  "/_layout/staking/$asset": typeof LayoutStakingAssetRouteWithChildren
  "/_layout/defi/": typeof LayoutDefiIndexRoute
  "/_layout/staking/": typeof LayoutStakingIndexRoute
  "/_layout/defi/positions/$positionAddress": typeof LayoutDefiPositionsPositionAddressRoute
  "/_layout/defi/protocols/$protocolKey": typeof LayoutDefiProtocolsProtocolKeyRoute
  "/_layout/defi/stablecoins/$tokenAddress": typeof LayoutDefiStablecoinsTokenAddressRoute
  "/_layout/staking/$asset/claim": typeof LayoutStakingAssetClaimRoute
  "/_layout/staking/$asset/stake": typeof LayoutStakingAssetStakeRoute
  "/_layout/staking/$asset/unstake": typeof LayoutStakingAssetUnstakeRoute
  "/_layout/defi/positions/": typeof LayoutDefiPositionsIndexRoute
  "/_layout/defi/protocols/": typeof LayoutDefiProtocolsIndexRoute
  "/_layout/defi/stablecoins/": typeof LayoutDefiStablecoinsIndexRoute
  "/_layout/staking/$asset/": typeof LayoutStakingAssetIndexRoute
  "/_layout/defi/pool/$tokenAddress/$protocolId": typeof LayoutDefiPoolTokenAddressProtocolIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/defi"
    | "/swap"
    | "/defi/positions"
    | "/defi/protocols"
    | "/defi/stablecoins"
    | "/staking/$asset"
    | "/defi/"
    | "/staking/"
    | "/defi/positions/$positionAddress"
    | "/defi/protocols/$protocolKey"
    | "/defi/stablecoins/$tokenAddress"
    | "/staking/$asset/claim"
    | "/staking/$asset/stake"
    | "/staking/$asset/unstake"
    | "/defi/positions/"
    | "/defi/protocols/"
    | "/defi/stablecoins/"
    | "/staking/$asset/"
    | "/defi/pool/$tokenAddress/$protocolId"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/swap"
    | "/"
    | "/defi"
    | "/staking"
    | "/defi/positions/$positionAddress"
    | "/defi/protocols/$protocolKey"
    | "/defi/stablecoins/$tokenAddress"
    | "/staking/$asset/claim"
    | "/staking/$asset/stake"
    | "/staking/$asset/unstake"
    | "/defi/positions"
    | "/defi/protocols"
    | "/defi/stablecoins"
    | "/staking/$asset"
    | "/defi/pool/$tokenAddress/$protocolId"
  id:
    | "__root__"
    | "/_layout"
    | "/_layout/defi"
    | "/_layout/swap"
    | "/_layout/"
    | "/_layout/defi/positions"
    | "/_layout/defi/protocols"
    | "/_layout/defi/stablecoins"
    | "/_layout/staking/$asset"
    | "/_layout/defi/"
    | "/_layout/staking/"
    | "/_layout/defi/positions/$positionAddress"
    | "/_layout/defi/protocols/$protocolKey"
    | "/_layout/defi/stablecoins/$tokenAddress"
    | "/_layout/staking/$asset/claim"
    | "/_layout/staking/$asset/stake"
    | "/_layout/staking/$asset/unstake"
    | "/_layout/defi/positions/"
    | "/_layout/defi/protocols/"
    | "/_layout/defi/stablecoins/"
    | "/_layout/staking/$asset/"
    | "/_layout/defi/pool/$tokenAddress/$protocolId"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  LayoutRoute: typeof LayoutRouteWithChildren
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/_layout": {
      id: "/_layout"
      path: ""
      fullPath: "/"
      preLoaderRoute: typeof LayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_layout/": {
      id: "/_layout/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof LayoutIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/swap": {
      id: "/_layout/swap"
      path: "/swap"
      fullPath: "/swap"
      preLoaderRoute: typeof LayoutSwapRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/defi": {
      id: "/_layout/defi"
      path: "/defi"
      fullPath: "/defi"
      preLoaderRoute: typeof LayoutDefiRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/staking/": {
      id: "/_layout/staking/"
      path: "/staking"
      fullPath: "/staking/"
      preLoaderRoute: typeof LayoutStakingIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/defi/": {
      id: "/_layout/defi/"
      path: "/"
      fullPath: "/defi/"
      preLoaderRoute: typeof LayoutDefiIndexRouteImport
      parentRoute: typeof LayoutDefiRoute
    }
    "/_layout/staking/$asset": {
      id: "/_layout/staking/$asset"
      path: "/staking/$asset"
      fullPath: "/staking/$asset"
      preLoaderRoute: typeof LayoutStakingAssetRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/defi/stablecoins": {
      id: "/_layout/defi/stablecoins"
      path: "/stablecoins"
      fullPath: "/defi/stablecoins"
      preLoaderRoute: typeof LayoutDefiStablecoinsRouteImport
      parentRoute: typeof LayoutDefiRoute
    }
    "/_layout/defi/protocols": {
      id: "/_layout/defi/protocols"
      path: "/protocols"
      fullPath: "/defi/protocols"
      preLoaderRoute: typeof LayoutDefiProtocolsRouteImport
      parentRoute: typeof LayoutDefiRoute
    }
    "/_layout/defi/positions": {
      id: "/_layout/defi/positions"
      path: "/positions"
      fullPath: "/defi/positions"
      preLoaderRoute: typeof LayoutDefiPositionsRouteImport
      parentRoute: typeof LayoutDefiRoute
    }
    "/_layout/staking/$asset/": {
      id: "/_layout/staking/$asset/"
      path: "/"
      fullPath: "/staking/$asset/"
      preLoaderRoute: typeof LayoutStakingAssetIndexRouteImport
      parentRoute: typeof LayoutStakingAssetRoute
    }
    "/_layout/defi/stablecoins/": {
      id: "/_layout/defi/stablecoins/"
      path: "/"
      fullPath: "/defi/stablecoins/"
      preLoaderRoute: typeof LayoutDefiStablecoinsIndexRouteImport
      parentRoute: typeof LayoutDefiStablecoinsRoute
    }
    "/_layout/defi/protocols/": {
      id: "/_layout/defi/protocols/"
      path: "/"
      fullPath: "/defi/protocols/"
      preLoaderRoute: typeof LayoutDefiProtocolsIndexRouteImport
      parentRoute: typeof LayoutDefiProtocolsRoute
    }
    "/_layout/defi/positions/": {
      id: "/_layout/defi/positions/"
      path: "/"
      fullPath: "/defi/positions/"
      preLoaderRoute: typeof LayoutDefiPositionsIndexRouteImport
      parentRoute: typeof LayoutDefiPositionsRoute
    }
    "/_layout/staking/$asset/unstake": {
      id: "/_layout/staking/$asset/unstake"
      path: "/unstake"
      fullPath: "/staking/$asset/unstake"
      preLoaderRoute: typeof LayoutStakingAssetUnstakeRouteImport
      parentRoute: typeof LayoutStakingAssetRoute
    }
    "/_layout/staking/$asset/stake": {
      id: "/_layout/staking/$asset/stake"
      path: "/stake"
      fullPath: "/staking/$asset/stake"
      preLoaderRoute: typeof LayoutStakingAssetStakeRouteImport
      parentRoute: typeof LayoutStakingAssetRoute
    }
    "/_layout/staking/$asset/claim": {
      id: "/_layout/staking/$asset/claim"
      path: "/claim"
      fullPath: "/staking/$asset/claim"
      preLoaderRoute: typeof LayoutStakingAssetClaimRouteImport
      parentRoute: typeof LayoutStakingAssetRoute
    }
    "/_layout/defi/stablecoins/$tokenAddress": {
      id: "/_layout/defi/stablecoins/$tokenAddress"
      path: "/$tokenAddress"
      fullPath: "/defi/stablecoins/$tokenAddress"
      preLoaderRoute: typeof LayoutDefiStablecoinsTokenAddressRouteImport
      parentRoute: typeof LayoutDefiStablecoinsRoute
    }
    "/_layout/defi/protocols/$protocolKey": {
      id: "/_layout/defi/protocols/$protocolKey"
      path: "/$protocolKey"
      fullPath: "/defi/protocols/$protocolKey"
      preLoaderRoute: typeof LayoutDefiProtocolsProtocolKeyRouteImport
      parentRoute: typeof LayoutDefiProtocolsRoute
    }
    "/_layout/defi/positions/$positionAddress": {
      id: "/_layout/defi/positions/$positionAddress"
      path: "/$positionAddress"
      fullPath: "/defi/positions/$positionAddress"
      preLoaderRoute: typeof LayoutDefiPositionsPositionAddressRouteImport
      parentRoute: typeof LayoutDefiPositionsRoute
    }
    "/_layout/defi/pool/$tokenAddress/$protocolId": {
      id: "/_layout/defi/pool/$tokenAddress/$protocolId"
      path: "/pool/$tokenAddress/$protocolId"
      fullPath: "/defi/pool/$tokenAddress/$protocolId"
      preLoaderRoute: typeof LayoutDefiPoolTokenAddressProtocolIdRouteImport
      parentRoute: typeof LayoutDefiRoute
    }
  }
}

interface LayoutDefiPositionsRouteChildren {
  LayoutDefiPositionsPositionAddressRoute: typeof LayoutDefiPositionsPositionAddressRoute
  LayoutDefiPositionsIndexRoute: typeof LayoutDefiPositionsIndexRoute
}

const LayoutDefiPositionsRouteChildren: LayoutDefiPositionsRouteChildren = {
  LayoutDefiPositionsPositionAddressRoute:
    LayoutDefiPositionsPositionAddressRoute,
  LayoutDefiPositionsIndexRoute: LayoutDefiPositionsIndexRoute,
}

const LayoutDefiPositionsRouteWithChildren =
  LayoutDefiPositionsRoute._addFileChildren(LayoutDefiPositionsRouteChildren)

interface LayoutDefiProtocolsRouteChildren {
  LayoutDefiProtocolsProtocolKeyRoute: typeof LayoutDefiProtocolsProtocolKeyRoute
  LayoutDefiProtocolsIndexRoute: typeof LayoutDefiProtocolsIndexRoute
}

const LayoutDefiProtocolsRouteChildren: LayoutDefiProtocolsRouteChildren = {
  LayoutDefiProtocolsProtocolKeyRoute: LayoutDefiProtocolsProtocolKeyRoute,
  LayoutDefiProtocolsIndexRoute: LayoutDefiProtocolsIndexRoute,
}

const LayoutDefiProtocolsRouteWithChildren =
  LayoutDefiProtocolsRoute._addFileChildren(LayoutDefiProtocolsRouteChildren)

interface LayoutDefiStablecoinsRouteChildren {
  LayoutDefiStablecoinsTokenAddressRoute: typeof LayoutDefiStablecoinsTokenAddressRoute
  LayoutDefiStablecoinsIndexRoute: typeof LayoutDefiStablecoinsIndexRoute
}

const LayoutDefiStablecoinsRouteChildren: LayoutDefiStablecoinsRouteChildren = {
  LayoutDefiStablecoinsTokenAddressRoute:
    LayoutDefiStablecoinsTokenAddressRoute,
  LayoutDefiStablecoinsIndexRoute: LayoutDefiStablecoinsIndexRoute,
}

const LayoutDefiStablecoinsRouteWithChildren =
  LayoutDefiStablecoinsRoute._addFileChildren(
    LayoutDefiStablecoinsRouteChildren,
  )

interface LayoutDefiRouteChildren {
  LayoutDefiPositionsRoute: typeof LayoutDefiPositionsRouteWithChildren
  LayoutDefiProtocolsRoute: typeof LayoutDefiProtocolsRouteWithChildren
  LayoutDefiStablecoinsRoute: typeof LayoutDefiStablecoinsRouteWithChildren
  LayoutDefiIndexRoute: typeof LayoutDefiIndexRoute
  LayoutDefiPoolTokenAddressProtocolIdRoute: typeof LayoutDefiPoolTokenAddressProtocolIdRoute
}

const LayoutDefiRouteChildren: LayoutDefiRouteChildren = {
  LayoutDefiPositionsRoute: LayoutDefiPositionsRouteWithChildren,
  LayoutDefiProtocolsRoute: LayoutDefiProtocolsRouteWithChildren,
  LayoutDefiStablecoinsRoute: LayoutDefiStablecoinsRouteWithChildren,
  LayoutDefiIndexRoute: LayoutDefiIndexRoute,
  LayoutDefiPoolTokenAddressProtocolIdRoute:
    LayoutDefiPoolTokenAddressProtocolIdRoute,
}

const LayoutDefiRouteWithChildren = LayoutDefiRoute._addFileChildren(
  LayoutDefiRouteChildren,
)

interface LayoutStakingAssetRouteChildren {
  LayoutStakingAssetClaimRoute: typeof LayoutStakingAssetClaimRoute
  LayoutStakingAssetStakeRoute: typeof LayoutStakingAssetStakeRoute
  LayoutStakingAssetUnstakeRoute: typeof LayoutStakingAssetUnstakeRoute
  LayoutStakingAssetIndexRoute: typeof LayoutStakingAssetIndexRoute
}

const LayoutStakingAssetRouteChildren: LayoutStakingAssetRouteChildren = {
  LayoutStakingAssetClaimRoute: LayoutStakingAssetClaimRoute,
  LayoutStakingAssetStakeRoute: LayoutStakingAssetStakeRoute,
  LayoutStakingAssetUnstakeRoute: LayoutStakingAssetUnstakeRoute,
  LayoutStakingAssetIndexRoute: LayoutStakingAssetIndexRoute,
}

const LayoutStakingAssetRouteWithChildren =
  LayoutStakingAssetRoute._addFileChildren(LayoutStakingAssetRouteChildren)

interface LayoutRouteChildren {
  LayoutDefiRoute: typeof LayoutDefiRouteWithChildren
  LayoutSwapRoute: typeof LayoutSwapRoute
  LayoutIndexRoute: typeof LayoutIndexRoute
  LayoutStakingAssetRoute: typeof LayoutStakingAssetRouteWithChildren
  LayoutStakingIndexRoute: typeof LayoutStakingIndexRoute
}

const LayoutRouteChildren: LayoutRouteChildren = {
  LayoutDefiRoute: LayoutDefiRouteWithChildren,
  LayoutSwapRoute: LayoutSwapRoute,
  LayoutIndexRoute: LayoutIndexRoute,
  LayoutStakingAssetRoute: LayoutStakingAssetRouteWithChildren,
  LayoutStakingIndexRoute: LayoutStakingIndexRoute,
}

const LayoutRouteWithChildren =
  LayoutRoute._addFileChildren(LayoutRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  LayoutRoute: LayoutRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
